import { MouseEventHandler } from 'react';

import { LogoProps } from '@contentservice/shared/components/content-card/logo.model';

export interface ITile {
  image?: string;
  imageAlt: string;
  imgUrl: string;
  imgAriaLabel: string;
  /** Different heading levels so it has to be sanitised html string. */
  heading: string;
  paragraph1: string;
  paragraph2?: string;
  btnText?: string;
  btnAltText?: string;
  btnUrl?: string;
  logo?: LogoProps;
  partnerLogo?: string;
  partnerLogoAlt?: string;
  sponsored?: boolean;

  isDesktopView?: boolean;
  /** If optional button should show as link */
  isLink?: boolean;

  /** click handler that handles routing, analytics etc. */
  btnClickHandler?: MouseEventHandler<HTMLAnchorElement | HTMLButtonElement>;
  /** click handler that handles routing, analytics etc. */
  imgClickHandler?: MouseEventHandler<HTMLAnchorElement | HTMLButtonElement>;
}

export interface IInfoTile {
  heading: string;
  body: string;
  btnText?: string;
  btnAltText?: string;
  btnUrl?: string;

  background?: InfoTileStyle | string;

  /** Option dropdown in contentful for content guys to select which visual variant */
  variant: InfoTileVariant | string;
  /** Core icon name */
  iconName?: string;
  graphicUrl?: string;
  /** the position in the list of boxed content that this particular one sits in. */
  position?: number; // should only come from middle layer, not from contentful
  /** Changes optional button to an anchor tag.  */
  isLink?: boolean;

  /** click handler that handles routing, analytics etc. */
  btnClickHandler?: MouseEventHandler<HTMLAnchorElement | HTMLButtonElement>;
}

export enum InfoTileVariant {
  icon = 'icon',
  numbered = 'numbered',
  graphic = 'graphic',
  none = 'none',
}

export enum InfoTileStyle {
  filled = 'filled',
  bordered = 'bordered',
}

export interface IRichText {
  /** Html string that changes to either h1, h2, or h3. */
  heading: string;
  /** Html string that gets generated from rich text. */
  paragraph1: string;
  /** Optional last paragraph that shows as smaller text. */
  paragraph2?: string;
}
